function e(e){return t=>!e(t)}export{e as isNot};
//# sourceMappingURL=isNot-B4-j8qzt.js.map